// flickity Slider
$(function () {
    // Single Slider
    if($('.singleSlider').length > 0){
        $('.singleSlider').flickity({
            //options            
            cellAlign: 'left',
            wrapAround: true,
            contain: true,
            pageDots: true,
            prevNextButtons: true,
            imagesLoaded: true,
            adaptiveHeight: true, 
            draggable: true,
        });
    };

    // =========================
    // Group Slider
    // =========================
    if ($('.groupSlider').length > 0) {
        function initGroupSlider() {
            $('.groupSlider').each(function () {
                let $this = $(this);

                // destroy previous flickity if exists
                if ($this.data('flickity')) {
                    $this.flickity('destroy');
                }

                let cellCount = $this.children().length;
                if (cellCount === 0) return; // no cells, skip

                let match = $this.attr('class').match(/slide-item-(\d+)/);
                let baseCount = match ? parseInt(match[1]) : null;

                // viewport width check
                let winW = window.innerWidth;
                let hideDots = false;

                if (baseCount && winW > 1024) {
                    hideDots = cellCount === baseCount;
                } else if (baseCount && winW <= 1024 && winW > 600) {
                    if (baseCount === 3) {
                        hideDots = cellCount === 2;
                    } else if (baseCount === 4) {
                        hideDots = cellCount === 3;
                    }
                } else if (winW <= 600) {
                    hideDots = false;
                }

                $this.flickity({
                    cellAlign: cellCount < 3 ? 'left' : 'center',
                    wrapAround: false,
                    groupCells: true,
                    contain: true,
                    autoPlay: 20000,
                    pauseAutoPlayOnHover: false,
                    pageDots: hideDots ? false : true,
                    prevNextButtons: false,
                    imagesLoaded: true
                });
            });
        }

        // init on load
        initGroupSlider();
        // re-init on resize
        $(window).on('resize', function () {
            initGroupSlider();
        });
    }

    // =========================
    // Logo Slider (continuous ticker)
    // =========================
    if ($('.logoSlider').length) {
    $('.logoSlider').each(function () {
        const $carousel = $(this);

        // init Flickity
        $carousel.flickity({
            cellAlign: 'left',
            contain: true,
            wrapAround: true,
            draggable: false,
            prevNextButtons: false,
            pageDots: false,
            autoPlay: false,
        });

        const flkty = $carousel.data('flickity');
        const SPEED = 0.8; // pixels per frame
        let paused = false;

        // pause on hover
        $carousel.on('mouseenter focusin', () => paused = true);
        $carousel.on('mouseleave focusout', () => paused = false);

        // main animate function
        function animate() {
            if (!paused) {
                flkty.x -= SPEED;
                if (Math.abs(flkty.x) >= flkty.slideableWidth) {
                    flkty.x = 0;
                }
                flkty.positionSlider();
                flkty.dispatchEvent('scroll', null, [flkty.x]);
            }
            requestAnimationFrame(animate);
        }

        // ensure height + start animation only after images loaded
        $carousel.on('imagesLoaded.flickity', function () {
            $carousel.flickity('resize');

            // थोड़ा delay देकर animation शुरू करो ताकि height fix हो जाए
            setTimeout(() => {
                animate();
            }, 100);
        });

        // fallback: अगर imagesLoaded event miss हो जाए तो भी run करो
        setTimeout(() => {
            $carousel.flickity('resize');
            animate();
        }, 800);
    });
}

    // =========================
    // Main Carousel + Thumbs
    // =========================
    const mainCarousel = document.querySelector('.main-carousel');
    if (mainCarousel) {
        const flk = new Flickity(mainCarousel, {
            wrapAround: true,
            pageDots: true,
            prevNextButtons: true,
            adaptiveHeight: true,
            imagesLoaded: true
        });

        const thumbs = document.querySelectorAll('#thumbsDesktop .thumb');
        thumbs.forEach((t, i) => t.onclick = () => flk.select(i));

        const setActive = i => thumbs.forEach((t, j) =>
            t.classList.toggle('active', i === j)
        );

        flk.on('change', setActive);
        flk.on('ready', () => setActive(flk.selectedIndex));
    }
});
